module.exports = __webpack_public_path__ + "static/media/ServiceRules.4d21e0e4.pdf";